// src/context/ProjectContext.js

import React, { createContext, useReducer } from 'react';

const ProjectContext = createContext();

const initialState = {
  projectTitle: '',
  styleChoices: {
    device: 'Desktop',
    theme: 'light',
    palette: 'Classic Light',
    font: 'Native UI'
  }
};

const projectReducer = (state, action) => {
  switch (action.type) {
    case 'SET_PROJECT_TITLE':
      return {
        ...state,
        projectTitle: action.payload,
      };
    case 'SET_STYLE_CHOICES':
      return {
        ...state,
        styleChoices: action.payload,
      };
    case 'SET_PROJECT_DETAILS':
      return {
        ...state,
        projectTitle: action.payload.title,
        styleChoices: action.payload.styleChoices || state.styleChoices
      };
    default:
      return state;
  }
};

const ProjectProvider = ({ children }) => {
  const [state, dispatch] = useReducer(projectReducer, initialState);

  return (
    <ProjectContext.Provider value={{ state, dispatch }}>
      {children}
    </ProjectContext.Provider>
  );
};

export { ProjectContext, ProjectProvider };